import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useProfileQuery } from "@/hooks/profile/useProfileQuery";

export const useGymReservationMessage = (gymId: string | null) => {
  const { data: profile } = useProfileQuery();

  return useQuery({
    queryKey: ['gym-reservation-message', gymId],
    queryFn: async () => {
      if (!gymId) return null;

      const { data: gym, error } = await supabase
        .from('gyms')
        .select('reservation_message')
        .eq('id', gymId)
        .maybeSingle();

      if (error) throw error;
      return gym?.reservation_message || '';
    },
    enabled: !!gymId && !!profile,
  });
};